import Image from "~/components/Image";
import {Pagination, Table, Tag} from "antd";
import {
	renderDate,
	numberFormat,
} from "~/utils";
import ReceiptAction from "./ReceiptAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

function ReceiptTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const {tableHeight} = useContext(AppContext);

	const handleEditClick = (item) => {
		setItemEdit(item);
		openModal('addEdit');
	}

	const handleDeleteClick = (item) => {
		setItemEdit(item);
		openModal('delete');
	}

	const columns = [
		{ title: 'Mã phiếu', dataIndex: 'code', key: "code", width: '100px', render: (_, item) => (<div>PT{item?.id}</div>)},
		{ title: 'Ngày thu', dataIndex: 'time', key: "time", width: '120px', render: (_, item) => (<div><p>{renderDate(item?.time)}</p></div>)},
		{ title: 'Loại thu', dataIndex: 'category', key: 'category', width: '220px', render: (_, item) => (<div>{item.category?.name}</div>)},
		{ title: 'Công ty', dataIndex: 'company', key: "company", width: '130px', render: (_, item) => (<Tag color={item?.company.badge}>{item?.company.label}</Tag>)},
		{ title: 'Đối tượng', dataIndex: 'user', key: "user", width: '220px', render: (_, item) => (
			item.user?.id && (
			<div className="d-flex gap align-items">
				<div className="avatar"><Image src={item.user?.avatar}/></div>
				<div>
					<b>{item.user?.firstname + ' ' + item.user?.lastname}</b>
					<p>{item.user?.username}</p>
				</div>
			</div>
		))},
		{ title: 'Số tiền thu', dataIndex: 'price', key: "price", width: '180px', render: (_, item) => (<p><b>{numberFormat(item?.price)}đ</b></p>)},
		{ title: 'Ghi chú', dataIndex: 'note', key: "note", render: (_, item) => (item?.note)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<ReceiptAction
				key={item.id}
				item={item}
				onClickEdit={handleEditClick}
				onClickDelete={handleDeleteClick}
			/>
		)},
	];

	const dataSource = items.map(row => ({
		key: row.id,
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y: tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange} showSizeChanger={false} />
		</div>
	)
}

export default ReceiptTable;

